import { Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { IScreen, IState, IUser } from '../../models/states';
import { changePassword } from '../../store/actions/userActions';
import MyButton from '../UI/MyButton/MyButton';
import ChangePasswordForm from './ChangePasswordForm';

const ProfileInfo = props => {
  const [changePasswordDialog, setChangePasswordDialog]: any = useState(false);
  const accessToken: string = props.user.access_token;
  const user = props.user;
  const renderProfileInfo = (label: string, value: string) => {
    return (
      <div style={{ display: 'flex', marginBottom: '1rem', minWidth: '25rem' }}>
        <Typography
          style={{
            width: '10rem',
            fontWeight: 'bold',
            textTransform: 'uppercase'
          }}
        >
          {label}
        </Typography>
        <Typography style={{ width: '10rem' }}>{value}</Typography>
      </div>
    );
  };
  const handleSubmit = (values: any) => {
    props.changePassword({
      email: user.email,
      old_password: values.oldPassword,
      new_password: values.newPassword,
      access_token: accessToken
    });
    setChangePasswordDialog(false);
  };

  return (
    <div>
      {renderProfileInfo('Name', props.user.name)}
      {renderProfileInfo('Email', props.user.email)}
      {renderProfileInfo('Role', props.user.role)}
      {renderProfileInfo(
        'Screens',
        props.user.screens
          .map((screenId: string) => {
            if (props.screenMap[screenId]) {
              return props.screenMap[screenId].name;
            } else {
              return '';
            }
          })
          .join(', ')
      )}
      <MyButton
        disabled={changePasswordDialog}
        style={{ marginBottom: '1rem' }}
        btnType={'yellow'}
        onClick={() => setChangePasswordDialog(true)}
      >
        Change Password
      </MyButton>
      {changePasswordDialog && <ChangePasswordForm onSubmit={handleSubmit} />}
    </div>
  );
};
interface IProfileInfoDispatchProps {
  changePassword: (payload: any) => any;
}
const mapDispatchToProps: IProfileInfoDispatchProps = {
  changePassword
};

export interface IProfileInfoState {
  user: IUser;
  screenMap: { string: IScreen };
}
const mapStateToProps = (state: IState) => {
  return {
    user: state.user.userInfo,
    screenMap: state.screens.screenMap
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileInfo);
